__turbopack_context__.v({
  "loader": "FeedLoadingState-module__ZCW8sq__loader",
  "root": "FeedLoadingState-module__ZCW8sq__root",
});
